import {
  MockMap,
} from '@ama-sdk/core';
import {
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  createJourney,
  createMockData,
  createMockDataWithResponse,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  etktAndFFBoardingPassResult,
  journeys,
  noItemToPayError,
} from '../../mock/data';
import {
  email,
  phone,
} from '../../mock/dictionaries';
import {
  assignSeatToJourneyElements,
  retrieveSeatMapsJourneyDriven,
} from './common/seatmap';

const journeyElementIds = journeys[0].journeyElements.map((je: JourneyElementCommon) => je.id);
const seatmap = retrieveSeatMapsJourneyDriven(journeys[0], journeys[0].travelers.map((t) => t.id).filter((id): id is string => !!id));

/**
 * OW 1Journey
 * 1ADT
 * No baggage
 */
export const ow1Journey1AdtUpdateContact: MockMap = {
  assignSeatToJourneyElement: assignSeatToJourneyElements(journeys[0], seatmap).map((seat) => createMockDataWithResponse(seat, 201)),
  generateBoardingPasses: [createMockDataWithResponse(combineBoardingPassResults(etktAndFFBoardingPassResult, {
    journeyElementIds
  }).items, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockData(noItemToPayError)],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [createMockDataWithResponse([createJourney({
    template: journeys[0]
  })], 201)],
  retrieveJourney: [
    createMockData(
      createJourney({
        template: {
          ...journeys[0],
          acceptance: AcceptanceRepository.ACCEPTED,
          contacts: [{
            ...email,
            travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
          }, {
            ...phone,
            travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
          }]
        }
      })
    )
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)],
  addContactsToJourney: [createMockDataWithResponse([{
    ...email,
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
  }, {
    ...phone,
    travelerIds: ['JOURNEY-TRAVELER-0-MOCK']
  }], 201)]
};
